//const BaseUrl = "https://anandaerpinapi.azurewebsites.net";
const BaseUrl = "https://dialerpinapi.azurewebsites.net";
const apiUrl_dialerp = "https://dialerpinapi.azurewebsites.net";
const apiTest_Url = "https://erpinuat.azurewebsites.net";
const Unichat_Url = "https://unichat.erpthemes.com";
const Appname = "Universal Dairy";
const subID = 10417;

let Authorization_Token = "";

const staticToken =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InVuaXZlcnNhbEBnbWFpbC5jb20iLCJzaWQiOiIxMDQxNyIsImp0aSI6ImQ2MWU4YTVlLTI5MTQtNGY3OS05MDcwLTJlOGFkY2M1YzcyMiIsIkFwcElEIjoiMCIsIkFwcE5hbWUiOiJEaWFsRXJwV2ViIiwiTGVkZ2VySUQiOiIxMDAyIiwiTGVkZ2VyTmFtZSI6IlZpdmVrIEd1cHRhIiwiQ29tcGFueU5hbWUiOiJVbml2ZXJzYWwgRGFpcnkgVGVjaCIsIlJvbGVJRCI6IjEiLCJleHAiOjE3NzYxNDIzNDUsImlzcyI6ImRpYWxlcnAuaW4iLCJhdWQiOiJkaWFsZXJwLmluIn0.Psw-Oy27P_Q0qj91G7Zo5o7UMuLHwtG9woy8bLxGbvA";
let LoggedInUserID = null;
let LoggedInUserName = null;
let AUTH_KEY =
  "Jj8S7aWpE1rxvJrSTNDYPC3a7qgQIsuWfZ5FZFqd4zsGWMxYh4Vu6P3DcZOcpbBtkWIrtLLp5w7XBTZKIKzKm8cdxLpgWSvzxwNFTENhM6E=";

function setLogindata(data) {
  // console.log("Setting login data:", data);
  Authorization_Token = data ? data.loginKey : "";
  LoggedInUserID = data ? data.partySr : null;
  // LoggedInUserName = data.userName;
}

function setUserdata(data) {
  //console.log("Setting login data:", data);

  LoggedInUserName = data ? data.LedgerName : null;
}

const characterEncoding = "UTF-8";
const key = "0e628f15575e4a7189ec11a50301bb70";

const cipherTransformation = "AES/CBC/PKCS5Padding";
const aesEncryptionAlgorithm = "AES";

export {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
  setUserdata,
  characterEncoding,
  key,
  cipherTransformation,
  aesEncryptionAlgorithm,Unichat_Url
};
